(() => {
  function init(root = document) {
    root.querySelectorAll('[data-tu-product]').forEach(section => {
      if (section.dataset.initialized) return;
      section.dataset.initialized = 'true';
      const gallery = section.querySelector('[data-tu-gallery]');
      const slides = [...gallery.querySelectorAll('[data-slide]')];
      const thumbs = [...gallery.querySelectorAll('[data-thumb]')];
      const dialog = gallery.querySelector('dialog');
      let previousFocus;
      let index = 0;
      const show = next => {
        index = (next + slides.length) % slides.length;
        slides.forEach((slide, i) => { slide.hidden = i !== index; });
        thumbs.forEach((thumb, i) => thumb.setAttribute('aria-pressed', String(i === index)));
      };
      thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => show(i)));
      gallery.addEventListener('keydown', event => {
        if (dialog.open) return;
        if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        show(index + (event.key === 'ArrowRight' ? 1 : -1));
        thumbs[index].focus();
      });
      slides.forEach(slide => slide.addEventListener('click', () => {
        const source = slide.querySelector('img');
        const image = dialog.querySelector('img');
        image.src = source.currentSrc || source.src;
        image.alt = source.alt;
        previousFocus = document.activeElement;
        dialog.showModal();
      }));
      dialog.querySelector('[data-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
      dialog.addEventListener('close', () => previousFocus?.focus());
      const form = section.querySelector('.tu-buy-form');
      if (!form) return;
      const select = form.querySelector('[data-variant]');
      const buttons = section.querySelectorAll('[data-submit]');
      const error = form.querySelector('[data-error-message]');
      let pending = false;
      const updateVariant = () => {
        const option = select.selectedOptions[0];
        const available = option.dataset.available === 'true';
        section.querySelectorAll('[data-price]').forEach(el => {
          if (el.tagName !== 'OPTION') el.textContent = option.dataset.price;
        });
        buttons.forEach(button => { button.disabled = !available || pending; button.textContent = pending ? section.dataset.addingLabel : available ? section.dataset.addLabel : section.dataset.soldLabel; });
        if (document.body.classList.contains('template-product')) {
          const url = new URL(location.href);
          url.searchParams.set('variant', option.value);
          history.replaceState({}, '', url);
        }
      };
      select.addEventListener('change', updateVariant);
      document.querySelectorAll('[data-tu-color]').forEach(link => link.addEventListener('click', () => {
        const option = [...select.options].find(option => option.textContent.trim() === link.dataset.tuColor);
        if (option) { select.value = option.value; updateVariant(); show(1); }
      }));
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (pending || !form.reportValidity()) return;
        if (select.selectedOptions[0].dataset.available !== 'true') return;
        pending = true;
        error.hidden = true;
        updateVariant();
        try {
          const response = await fetch(section.dataset.addUrl, {
            method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form)
          });
          const data = await response.json();
          if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : section.dataset.error);
          location.assign(section.dataset.cart);
        } catch (problem) {
          error.textContent = problem.message || section.dataset.error;
          error.hidden = false;
          pending = false;
          updateVariant();
        }
      });
      const sticky = section.querySelector('[data-sticky]');
      const footer = document.querySelector('.tu-footer');
      if (sticky) {
        let ticking = false;
        const refresh = () => {
          const rect = form.getBoundingClientRect();
          const footerVisible = footer && footer.getBoundingClientRect().top < innerHeight;
          sticky.hidden = rect.bottom > 100 || footerVisible;
          ticking = false;
        };
        const onScroll = () => { if (!ticking) { requestAnimationFrame(refresh); ticking = true; } };
        addEventListener('scroll', onScroll, { passive: true });
        addEventListener('resize', onScroll, { passive: true });
        document.addEventListener('shopify:section:unload', event => {
          if (event.target.contains(section)) {
            removeEventListener('scroll', onScroll);
            removeEventListener('resize', onScroll);
          }
        }, { once: true });
        refresh();
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
